<script>
	import { navigate } from "svelte-routing";
	import { Table, DropdownItem } from "sveltestrap";
	import CustomPaginate from "../../../components/CustomPaginate/Pagination.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	export let data;
	export let handleInactive;
	import { convert } from "../../../services/helpers";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<!-- <th>ID</th> -->
				<th>Group Name</th>
				<th>Created On</th>
				<th>Status</th>
				<th>Actions</th>
			</tr></thead
		>
		<tbody>
			{#if data}
				{#each data as { groupId, name, status, createdAt, updatedAt }}
					<tr>
						<!-- <td>
						<p
							class="link"
							on:click={() => navigate(`group/details/${id}`)}
						>
							<span class="link link-text">
								{id}
							</span>
						</p>
					</td> -->
						<td>
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<p
								class="link"
								on:click={() =>
									navigate(`group/details/${groupId}`)}
							>
								<span class="link link-text">
									{name}
								</span>
							</p>
						</td>
						<td>
							{convert(createdAt)}
						</td>
						<td>
							{#if status == true}
								<p class="status-bar status-bar-1">Active</p>
							{:else}
								<p class="status-bar status-bar-3">Inactive</p>
							{/if}
						</td>
						<!-- <td>
						{#if status === 3}
							<p class="status-bar status-bar-3">Incomplete</p>
						{/if}
					</td> -->
						<td>
							<TableDropdown>
								<DropdownItem
									on:click={() =>
										navigate(`group/details/${groupId}`)}
									>Details</DropdownItem
								>
								{#if status == true}
									<DropdownItem
										on:click={() =>
											handleInactive(groupId, status)}
										>Set as Inactive</DropdownItem
									>
								{:else}
									<DropdownItem
										on:click={() =>
											handleInactive(groupId, status)}
										>Set as Active</DropdownItem
									>
								{/if}
							</TableDropdown>
						</td>
					</tr>
				{/each}
			{/if}
		</tbody>
	</Table>
	{#if data.length == 0}
		<p class="text-center">No data to display</p>
	{/if}
	<CustomPaginate totalRecord={!data ? 0 : data.length} />
</LoaderContainer>
